import { values } from 'searchband-frontend-commons/util/object';

/**
 * Фабрика для создания фабрики свойства типа enum
 * @param {Set} enumMap
 * @param {*} defaultValue
 * @return {Function}
 */
export var enumPropsFactoryProvider = function enumPropsFactoryProvider(enumSet) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (value) {
    var currentDefaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultValue;
    return enumSet.has(value) ? value : currentDefaultValue;
  };
};

/**
 * Создание енум сета из значений объекта
 * @param {Object} object
 * @return {Set}
 */
export var objectToEnumMap = function objectToEnumMap(object) {
  return new Set(values(object));
};